import { serviceRoles } from "config/access";
import { DEGREE_LEVELS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import DegreeLevelsPage from "./container/DegreeLevelsPage";

export default function getRoute(userAuth) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: DEGREE_LEVELS,
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    withSidebar: true,
    withAppBar: true,
    component: DegreeLevelsPage,
  };
}
